import React from 'react'
import { connect } from 'react-redux'
import { Flex, FlexItem, LoadMore, Dialog, Toptips, Toast, ActionSheet } from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { Link, browserHistory } from 'react-router'
import leftPad from 'left-pad'
import { Page } from '../../components'
import { WKVisible } from '../../components/wk'
import ScheduleSigninItem from './ScheduleSigninItem'
import signinEmptyImg from '../../images/schedule/signin-empty.png'
import noSigninImg from '../../images/schedule/no-signin.png'
import signinedImg from '../../images/schedule/signined.png'


class SchduleCalendarPage extends React.Component {
    constructor (props) {
        super(props)
        const currentDateIst = new Date()
        const currentYear = currentDateIst.getFullYear()
        const currentMonth = currentDateIst.getMonth() + 1
        const currentDate = currentDateIst.getDate()
        
        this.currentYear = currentYear
        this.currentMonth = currentMonth
        this.currentDate = currentDate
        this.menu = [{
            label: '回复',
            onClick: () => this.setState({ isShowCommentDialog: true, isShowActionSheet: false }),
        }]

        this.state = {
            year: currentYear,
            month: currentMonth,
            date: currentDate,
            scheduleInfo: {},
            rankInfo: {},
            selectedDate: '',
            selectedSignin: null,
            myCalendars: {},
            isSigninPending: true,
            isPending: false,
            pendingText: '正在提交',
            isLike: false,
            likes: [],
            comments: [],
            isShowCommentDialog: false,
            selectedComment: '',
            comment: '',
            audioStatus: 'stop',
            audioDuration: 0,
            audioCurrentTime: 0,
            signinInfo: {},
            isShowActionSheet: false,
            isShowDelConfirmDialog: false,
            isShowDelSigninDialog: false,
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        document.title = '打卡日历'
        const dateStr = this.getStandardDate(this.state.year, this.state.month, this.state.date)
        this.currentDateStr = dateStr
        this.fetchCalendarData()
        this.fetchSignin(dateStr)
        this.setState({ selectedDate: dateStr })
    }
    fetchCalendarData () {
        axios.get(`/api/schedule/${this.props.params.id}/calendar`)
            .then(res => {
                this.setState({
                    myCalendars: res.data.data.calendar, 
                    scheduleInfo: res.data.data.schedule,
                    rankInfo: res.data.data.rank,
                })
            })
    }
    onClickDelComment () {
        this.setState({ isShowCommentDialog: true })
    }
    getCalendarData (year, month) {
        const thisMonthDay = new Date(year, month - 1, 1)
        const thisMonthFirstDay = thisMonthDay.getDay()
        const thisMonthTotalDates = new Date(year, month, 0)
        return {
            firstDay: thisMonthFirstDay === 0 ? 7 : thisMonthFirstDay,
            totalDates: thisMonthTotalDates.getDate()
        }
    }
    onClickDate (date) {
        const dateStr = this.getStandardDate(this.state.year, this.state.month, date)
        this.fetchSignin(dateStr)
        // if (this.state.selectedDate === dateStr) {
        //     this.setState({ selectedDate: `` })
        // } else {
            this.setState({ selectedDate: dateStr })
        // }
    }
    fetchSignin (dateStr) {
        this.setState({ isSigninPending: true, selectedSignin: null })
        axios.get(`/api/schedule/${this.props.params.id}/calendar_detail`, {
            params: {
                date: dateStr
            }
        })
            .then(res => {
                const signin_info = res.data.data.signin_info
                this.setState({
                    isSigninPending: false, 
                    selectedSignin: signin_info,
                    isLike: signin_info && signin_info.liked,
                    likes: signin_info && signin_info.likes,
                    comments: signin_info && signin_info.comments,
                    signinInfo: signin_info && signin_info.signin || {},
                })
            })

    }
    // 2017, 4, 5 => 转为标准的日期：2017-04-05
    getStandardDate (year, month, date) {
        return `${this.state.year}-${leftPad(this.state.month, 2, '0')}-${leftPad(date, 2, '0')}`
    }
    // 渲染日历每个日期
    renderDates () {
        const calendarData = this.getCalendarData(this.state.year, this.state.month)
        const { totalDates, firstDay } = calendarData
        const datesTpl = []
        let _date = 1
        // i 为日历的格子序号
        for (let i = 0; ; i ++) {
            let tpl
            let date = _date
            if (i + 1 < firstDay) {
                tpl = <li key={i}></li>
            } else {
                const dateStr = this.getStandardDate(this.state.year, this.state.month, date)
                const isDateActive = this.state.selectedDate === dateStr
                const isDateShouldSignin = this.state.myCalendars[dateStr] != null
                const isDateSignin = this.state.myCalendars[dateStr]
                // const isOverToday = this.getStandardDate(this.currentYear, this.currentMonth, this.currentDate) < dateStr
                tpl = (
                    <li key={i} onClick={e => this.onClickDate(date)}>
                        <div className={`li ${isDateActive ? 'active' : ''}`}>
                            {date}
                        </div>
                        <WKVisible show={!isDateActive && isDateShouldSignin} className="status">
                            <WKVisible show={isDateSignin}>
                                <img src={signinedImg} alt='' />
                            </WKVisible>
                            <WKVisible show={!isDateSignin}>
                                <img src={noSigninImg} alt='' />
                            </WKVisible>
                        </WKVisible>
                    </li>
                )
                _date ++
            }
            datesTpl.push(tpl)
            if (date >= totalDates) {
                break
            }
        }
        return datesTpl
    }
    onChangeMonth (action) {
        if (action === 'reduce') {
            if (this.state.month <= 1) {
                this.setState({ year: this.state.year - 1, month: 12 })
            } else {
                this.setState({ month: this.state.month - 1 })
            }
        } else {
            if (this.state.month >= 12) {
                this.setState({ year: this.state.year + 1, month: 1 })
            } else {
                this.setState({ month: this.state.month + 1 })
            }
        }
    }
    onClickLike () {
        const type = this.state.isLike ? 'cancel_like' : 'like'
        if (this.state.likes.some(item => item.account.id === this.props.account.id)) {
            this.state.likes = this.state.likes.filter(item => item.account.id !== this.props.account.id)
        } else {
            this.state.likes.push({account: this.props.account})
        }
        this.setState({ isLike: !this.state.isLike, likes: this.state.likes })
        axios.post(`/api/schedule/${this.props.params.id}/signin/${this.state.selectedSignin.signin.id}/${type}`)
    }
    onClickComment (id) {
        // 点了某人的评论
        if (id) {
            this.setState({ selectedComment: id, isShowActionSheet: true })
        } else {
            this.setState({ isShowCommentDialog: true })
        }
    }
    onSubmitComment () {
        const comment = this.state.comment.trim()
        if (!comment) {
            return this.showTip('内容不能为空')
        }
        const signinId = this.state.selectedSignin.signin.id
        const scheduleId = this.props.params.id
        this.setState({ isPending: true })
        axios.post(`/api/schedule/${scheduleId}/signin/${signinId}/comment/publish`, qs.stringify({
            content: this.state.comment,
            quote_id: this.state.selectedComment,
        }))
            .then(res => {
                const data = res.data.data
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.state.comments.push({
                    id: data.id,
                    account: data.account,
                    quote: data.quote_account,
                    content: comment,
                })
                this.setState({ isShowCommentDialog: false, comment: '', comments: this.state.comments })
            })
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    onAudioLoad () {
        const $player = this.$player
        this.setState({ audioDuration: ~~$player.duration })
    }
    onAudioTimeUpdate () {
        const currentTime = ~~this.$player.currentTime
        if (currentTime >= this.state.audioDuration) {
            this.setState({ audioStatus: 'pause', audioCurrentTime: 0 })
        } else {
            this.setState({ audioCurrentTime: ~~this.$player.currentTime })
        }
    }
    onPlay () {
        // console.log('play')
    }
    onPause () {
        // console.log('pause')
    }
    onClickAudio () {
        const $player = this.$player
        this.setState({ audioStatus: $player.paused ? 'playing' : 'pause' })
        $player.paused ? $player.play() : $player.pause()
    }
    onClickDelCommentOk () {
        const scheduleId = this.props.params.id
        const signinId = this.state.signinInfo.id
        const commentId = this.state.selectedComment
        axios.post(`/api/schedule/${scheduleId}/signin/${signinId}/comment/${commentId}/delete`)
            .then(res => this.fetchSignin())
    }
    onClickDelSignin(id, index) {
        this.setState({ isShowDelSigninDialog: true })
    }
    onClickDelSigninOk() {
        axios.post(`/api/schedule/${this.props.params.id}/signin/${this.state.signinInfo.id}/delete`)
        // this.state.signins = this.state.signins.filter((item, i) => i !== this.state.selectedSigninIndex)
        this.setState({ selectedSignin: null, isShowDelSigninDialog: false })
    }
    render() {
        const scheduleInfo = this.state.scheduleInfo
        const rankInfo = this.state.rankInfo
        const isInSigninDate = this.state.myCalendars[this.state.selectedDate] != null
        return (
            <div className='wk-page'>
                <audio
                    ref={r => this.$player = r}
                    preload="metadata"
                    src={this.state.signinInfo.audio_url}
                    width="1"
                    height="1"
                    onCanPlay={e => this.onAudioLoad()}
                    onTimeUpdate={e => this.onAudioTimeUpdate()}
                    onPlay={e => this.onPlay()}
                    onPause={e => this.onPause()}
                />
                <div className="schdule-calendar-page">
                    <div className="dashboard margin-bottom">
                        <div className="header">
                            <button className="invite-btn" onClick={e => location.assign(`/schedule/${this.props.params.id}/sharecard`)}>分享</button>
                            <div className="avatar" style={{backgroundImage: `url(${scheduleInfo.banner})`}}>
                            </div>
                            <div className="content">
                                <div className="title text-ellipsis" onClick={e => location.assign(`/schedule/${this.props.params.id}/rank`)}>
                                    {scheduleInfo.name || '-'}
                                </div>
                                <div className="days">
                                    累计打卡<span className='green'>{rankInfo.cumulative_days}</span>天
                                </div>
                                <div className="progress-wrap">
                                    <div className="progress">
                                        <div 
                                            className="active-progress" 
                                            style={{width: `${scheduleInfo.current_day/scheduleInfo.total_day * 100}%`}}
                                        >
                                        </div>
                                    </div>
                                    <div className="progress-text">
                                        <span className="bold">{scheduleInfo.current_day}</span>/{scheduleInfo.total_day}天
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="calendar-wrap">
                        <div className="calendar">
                            <Flex className='weui-flex header'>
                                <FlexItem 
                                    className='weui-flex__item'
                                    onClick={e => this.onChangeMonth('reduce')}
                                >
                                    <i className="iconfont icon-jiantou"></i>
                                </FlexItem>
                                <FlexItem className='weui-flex__item text-center'>
                                    {this.state.year}年{this.state.month}月
                                </FlexItem>
                                <FlexItem 
                                    className='weui-flex__item text-right'
                                    onClick={e => this.onChangeMonth('add')}
                                >
                                    <i className="iconfont icon-202"></i>
                                </FlexItem>
                            </Flex>
                            <div className="day-wrap">
                                <ul>
                                    <li>一</li>
                                    <li>二</li>
                                    <li>三</li>
                                    <li>四</li>
                                    <li>五</li>
                                    <li>六</li>
                                    <li>日</li>
                                </ul>
                            </div>
                            <div className="date-wrap">
                                <ul>
                                    { this.renderDates() }
                                </ul>
                            </div>
                        </div>
                        <p className='records-title'>我的打卡记录</p>
                        <WKVisible show={this.state.isSigninPending}>
                            <LoadMore loading>加载中...</LoadMore>
                        </WKVisible>
                        {/* 没有打卡信息 */}
                        <WKVisible show={!this.state.selectedSignin && !this.state.isSigninPending} className='signin-empty-wrap'>
                            <img src={signinEmptyImg} />
                            <WKVisible show={this.state.selectedDate === this.currentDateStr && isInSigninDate}>
                                <div className="text">今天尚未打卡？
                                    <Link to={`/schedule/${this.props.params.id}/signin/create`}>立即打卡</Link>
                                </div>
                            </WKVisible>
                            <WKVisible show={this.state.selectedDate < this.currentDateStr && isInSigninDate}>
                                <div className="text">坚持是生活态度，可别再忘了打卡</div>
                            </WKVisible>
                            <WKVisible show={this.state.selectedDate > this.currentDateStr && isInSigninDate}>
                                <div className="text">瞧这急性子，还没到打卡时间</div>
                            </WKVisible>
                            <WKVisible show={!isInSigninDate}>
                                <div className="text">当前时间不是打卡日</div>
                            </WKVisible>
                        </WKVisible>
                        {
                            this.state.selectedSignin && !this.state.isSigninPending && (
                                <div className='signins wk-border-line-before wk-position-rlt'>
                                    <ScheduleSigninItem
                                        account={this.state.selectedSignin.signin.account}
                                        signinInfo={this.state.selectedSignin.signin}
                                        images={this.state.selectedSignin.signin.images}
                                        onClickLike={e => this.onClickLike()}
                                        onSubmitComment={e => e}
                                        onClickComment={id => this.onClickComment(id)}
                                        isLike={this.state.isLike}
                                        likes={this.state.likes}
                                        comments={this.state.comments}
                                        onClickAudio={e => this.onClickAudio()}
                                        audioDuration={this.state.audioDuration}
                                        audioCurrentTime={this.state.audioCurrentTime}
                                        audioStatus={this.state.audioStatus}
                                        role={{is_manager: true}}
                                        onClickDelSignin={e => this.onClickDelSignin()}
                                    />
                                </div>
                            )
                        }
                        <Dialog type="ios" title='请输入评论' buttons={[
                            { label: '取消', type: 'default', onClick: e => this.setState({ isShowCommentDialog: false }) },
                            { label: '提交', onClick: e => this.onSubmitComment() }
                        ]} show={this.state.isShowCommentDialog}>
                            <textarea 
                                rows="4" 
                                onChange={e => this.setState({ comment: e.target.value })}
                                value={this.state.comment}
                            >
                            </textarea>
                        </Dialog>
                        <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
                        <Toast icon="loading" show={this.state.isPending}>{this.state.pendingText}</Toast>
                        <Dialog type="ios" title='' buttons={[
                            { label: '删除', type: 'default', onClick: () => this.onClickDelCommentOk() },
                            { label: '取消', onClick: () => this.setState({ isShowDelConfirmDialog: false }) }
                        ]} show={this.state.isShowDelConfirmDialog}>
                            确定删除评论吗？
                        </Dialog>
                        <Dialog type="ios" title='' buttons={[
                            { label: '确定', type: 'default', onClick: e => this.onClickDelSigninOk() },
                            { label: '取消', onClick: e => this.setState({ isShowDelSigninDialog: false }) }
                        ]} show={this.state.isShowDelSigninDialog}>
                            确定删除动态吗？
                        </Dialog>
                        <ActionSheet
                            menus={this.menu}
                            actions={[{
                                label: '取消',
                                onClick: e => this.setState({isShowActionSheet: false})
                            }]}
                            show={this.state.isShowActionSheet}
                            type="ios"
                            onRequestClose={e => this.setState({isShowActionSheet: false})}
                        />
                    </div>
                </div>
            </div>
        )
    }
}


export default connect(state => ({
    account: state.account,
}))(SchduleCalendarPage)


// WEBPACK FOOTER //
// ./src/pages/schedule/ScheduleCalendarPage.js